import { css } from 'styled-components';
import { SpacingName } from '../../theme';
import { TypographyName } from '../../theme/typography';
import { getSpacing, getTypography, rgba } from '../../theme/utils';
const height = 3.125;
export const label = _ref => {
  let {
    theme,
    $isDisabled,
    $error,
    $isChecked,
    $buttonish
  } = _ref;
  return css(["", " align-items:center;display:flex;position:relative;cursor:pointer;border-radius:.3rem;border:", ";background:transparent;height:", "rem;", " ", " ", " & > input{position:absolute;left:-9999px;margin:0;padding:0;}& > i{content:' ';flex-shrink:0;border:2px solid ", ";border-radius:50%;display:inline-flex;height:1rem;margin-right:.5rem;position:relative;transition:all .15s ease-in;width:1rem;", "}& > input:disabled ~ *{opacity:.4;}& > i:after{background-color:", ";border-radius:50%;content:' ';left:50%;transform:translate(-50%,-50%);opacity:0;position:absolute;top:50%;width:.5rem;height:.5rem;transition:opacity .1s ease-in;", "}& > input:focus ~ i{box-shadow:0px 0 4px ", ";}& > input:focus:checked ~ i{box-shadow:none;}& > input:checked ~ i:after{opacity:1;}"], getSpacing.padding(theme, $buttonish ? [0, SpacingName.SMALLER] : 0), $buttonish ? `1px solid ${theme.palettes.neutrals.light}` : 'none', height, $isDisabled && `
    cursor: not-allowed;
  `, $error && `
    border-color: ${theme.palettes.status.alert};
  `, $isChecked && `
    border-color: ${theme.palettes.neutrals.medium};
  `, theme.palettes.neutrals.darkest, $error && `
      border-color: ${theme.palettes.status.alert};
    `, theme.palettes.neutrals.darkest, $error && `
      background-color: ${theme.palettes.status.alert};
    `, rgba(theme.palettes.neutrals.darkest, 0.8));
};
export const text = _ref2 => {
  let {
    theme
  } = _ref2;
  return css(["", " line-height:initial;"], getTypography(theme, TypographyName.BODY));
};
//# sourceMappingURL=Radio.style.js.map